export default {
    ReplayDate: "Дата воспроизведения видео",
    null: "Нет данных",
    recover: "Восстановить",
    Dispatch: "Отправить",
    StartIntercom: "Начать переговорное устройство",
    Intercom: "Разговор...",
    Broadcast: "Начать трансляцию",
    StopBroadcast: "Остановить трансляцию",
    onRelay: "Включить удалённое реле",
    offRelay: "Выключить удалённое реле",
    onAlgorithm: "Включить реле алгоритма",
    offAlgorithm: "Выключить реле алгоритма",
    RelaySettings: "Настройки реле",
    MovementSpeed: "Скорость перемещения",
    MovementDistance: "Расстояние перемещения",
    Movement: "Включить/выключить расстояние перемещения",
    PTZControl: "Управление поворотной камерой",
    SetArea: "Настроить область",
    BasicParameters: "Основные параметры",
    PushNotifications: "Уведомления",
    OtherParameters: "Прочие параметры",
    VideoList: "Список записей",
    ServerIP: "IP сервера",
    ServerPort: "Порт сервера",
    ServerID: "ID сервера",
    ServerPwd: "Пароль сервера",
    DeviceID: "ID устройства",
    DeviceName: "Название устройства",
    CameraType: "Тип камеры",
    PleaseSelect: "Выберите",
    BulletCamera: "Купольная",
    DomeCamera: "Полусфера",
    SpeedDome: "Поворотная",
    ZoomableCamera: "Трансфокатор",
    DeviceUsername: "Имя пользователя устройства",
    DevicePwd: "Пароль устройства",
    ScreenshotTime: "Интервал снимков",
    SendInterval: "Интервал отправки",
    SlaveID: "Номер ведомого",
    LORAMode: "Режим LORA",
    SlaveMode: "Ведомый режим",
    MasterMode: "Ведущий режим",
    IPNotEmpty: "IP сервера не может быть пустым",
    PortNotEmpty: "Порт сервера не может быть пустым",
    IDNotEmpty: "ID сервера не может быть пустым",
    pwdNotEmpty: "Пароль сервера не может быть пустым",
    dIDNotEmpty: "ID устройства не может быть пустым",
    NameNoEmpty: "Название устройства не может быть пустым",
    TypeNoEmpty: "Тип камеры не может быть пустым",
    unameNoEmpty: "Имя пользователя устройства не может быть пустым",
    pwdNoEmpty: "Пароль устройства не может быть пустым",
    ScreenshotNoEmpty: "Интервал снимков не может быть пустым",
    SendNoEmpty: "Интервал отправки не может быть пустым",
    SlaveIDNoEmpty: "Номер ведомого не может быть пустым",
    LORANoEmpty: "Необходимо выбрать режим LORA",
    VideoParameters: "Параметры видео",
    Resolution: "Разрешение",
    HD: "HD",
    SD: "SD",
    Smooth: "Плавный",
    Bitrate: "Битрейт",
    BitrateNoEmpty: "Битрейт не может быть пустым",
    AudioParameters: "Параметры аудио",
    SpeakerVolume: "Громкость динамика",
    MicVolume: "Громкость микрофона",
    SpeakerVNoEmpty: "Громкость динамика не может быть пустой",
    MicVNoempty: "Громкость микрофона не может быть пустой",
    ISPInfo: "Параметры ISP",
    Contrast: "Контраст",
    Brightness: "Яркость",
    Sharpness: "Резкость",
    Saturation: "Насыщенность",
    ContrastNoEmpty: "Контраст 0~256, не может быть пустым",
    BrightnessNoEmpty: "Яркость 0~256, не может быть пустой",
    SharpnessNoEmpty: "Резкость 0~256, не может быть пустой",
    SaturationNoEmpty: "Насыщенность 0~256, не может быть пустой",
    WIFIHotspot: "Параметры WIFI",
    EncryptionMethod: "Шифрование",
    SSID: "SSID",
    WIFIPwd: "Пароль WiFi",
    enterEethod: "Введите способ шифрования",
    enterSSID: "Введите SSID",
    enterPWD: "Введите пароль WiFi",
    MethodNoEmpty: "Способ шифрования не может быть пустым",
    SSIDNoEmpty: "SSID не может быть пустым",
    WIFIPwdNoEmpty: "Пароль WiFi не может быть пустым",
    HTTPPush: "HTTP-уведомления",
    enterURL: "Введите URL",
    enterToken: "Введите token",
    enterTokenKey: "Введите tokenKey",
    URLNoEmpty: "URL не может быть пустым",
    TokenNoEmpty: "token не может быть пустым",
    TokenKeyNoEmpty: "tokenKey не может быть пустым",
    EmailPush: "Email-уведомления",
    ServiceAddress: "Адрес сервера",
    Port: "Порт",
    Subject: "Тема",
    "enterMQTTaddress  ": "Введите адрес MQTT-сервера",
    enterMQTTport: "Введите порт MQTT",
    enterusername: "Введите имя пользователя",
    enterSubject: "Введите тему",
    MQTTServiceNoEmpty: "Адрес MQTT не может быть пустым",
    MQTTPortNoEmpty: "Порт MQTT не может быть пустым",
    SubjectNoEmpty: "Тема не может быть пустой",
    enterPushStatus: "Введите статус уведомления",
    SerialPort: "Последовательный порт",
    SerialPortAddress: "Адрес порта",
    Token: "token",
    FTPNoEmpty: "Адрес FTP не может быть пустым",
    uNameNoEmpty: "Имя пользователя не может быть пустым",
    enterAddress: "Введите адрес порта",
    SerialNotEmpty: "Адрес порта не может быть пустым",
    FireAlarmParameters: "Параметры пожарной тревоги",
    FlameConfidence: "Достоверность пламени",
    SmokeConfidence: "Достоверность дыма",
    AlarmThreshold: "Порог тревоги",
    enteralarm: "Введите порог тревоги (число)",
    AlarmNotEmpty: "Порог тревоги не может быть пустым",
    Parameters: "Параметры распознавания электромобиля",
    HumanRecognition: "Достоверность распознавания человека",
    Confidence: "Достоверность распознавания электромобиля",
    Bicycle: "Достоверность распознавания велосипеда",
    enterZQNumber: "Введите корректное число",
    enterNumber: "Введите число от 1 до 1000",
    notImplemented: "Функция переговорного устройства пока недоступна",
    FailedModify: "Не удалось изменить параметры",
    OnlyMP3files: "Допускаются только файлы MP3",
    sureuploadfile: "Загрузить этот файл трансляции?",
    FailedopenNormally: "Ошибка открытия. Настройте после начала воспроизведения.",
    SettingsSuccessful: "Настройки сохранены",
    SettingsFailed: "Не удалось сохранить настройки",
    RequestError: "Ошибка запроса. Обратитесь к администратору.",
    enterIPAddress: "Введите IP сервера",
    enterServerPort: "Введите порт сервера",
    enterServerID: "Введите ID сервера",
    enterServerPwd: "Введите пароль сервера",
    enterDeviceID: "Введите ID устройства",
    enterDeviceName: "Введите название устройства",
    enterDeviceUname: "Введите имя пользователя устройства",
    enterDevicePwd: "Введите пароль устройства",
    enterScreenshot: "Введите интервал снимков (сек)",
    enterSending: "Введите интервал отправки (сек)",
    enterStack: "Введите номер ведомого",
    FrameRate: "Частота кадров",
    Email: "Email",
    enterEmail: "Введите email",
    emailNoEmpty: "Email не может быть пустым",
    Switch: "Переключатель",
    FTPpush: "FTP-уведомления",
    FTPaddress: "Адрес FTP",
    enterFTP: "Введите адрес FTP",
    enterSerial: "Введите адрес порта",
    MQTTPush: "MQTT-уведомления",
    enterMQTT: "Введите адрес MQTT-сервера",
    enterMQTTProt: "Введите порт MQTT",

    robinTime: "Время цикла",
    beginRobin: "Начать цикл",
    endRobin: "Остановить цикл",
    verticalSpeek: "Скорость по вертикали",
    levelSpeek: "Скорость по горизонтали",
    splitScreen: "Разделить экран",
    fullScreen: "Полный экран",
    closeAll: "Закрыть все",
    close: "Закрыть",
    screenshot: "Снимок",
    beginVideo: "Начать запись",
    cloudControl: "Управление камерой",
    showSite: "Показать место установки",
    endVideo: "Остановить запись",
    enterTime: "Введите время",
    SplitScreen: "Раздельный экран",
    Rotation30: "Время цикла не менее 30 сек",
    Rotation60: "Время цикла не менее 60 сек",
    handleAlarm: "Сначала обработайте тревогу",
    stopPotation: "Идёт запись. Остановите запись перед включением цикла.",
    currentRotation: "Недостаточно устройств для цикла",
    RotationActive: "Цикл активен, переключение окон недоступно",
    FailedgetList: "Не удалось загрузить список записей",
    notSwitching: "Цикл активен, переключение видео недоступно",
    selectWindow: "Выберите окно воспроизведения",
    currentWindow: "Текущее устройство в окне",
    playRecord: "Воспроизвести запись? Остановить текущую и воспроизвести выбранную?",
    Play: "Воспроизведение",
    VOD: "Воспроизведение недоступно. Проверьте камеру.",
    "Please handle the alarm first": "Сначала обработайте тревогу",
    HideLocation: "Скрыть место установки",
    ShowLocation: "Показать место установки",
    RotationIs: "Цикл активен, кнопка недоступна",
    RotaStopSearch: "Поиск приостановлен во время цикла",
    notPlayVideo: "В режиме цикла воспроизведение недоступно",
    NoVideo: "Нет воспроизводимого видео",
    ClosedSucc: "Закрыто",
    unableRecord: "В окне нет воспроизводимого видео",
    CurrentOffline: "Устройство не в сети",
    Window: "Окно",
    isProgress: "Идёт запись",
    openS: "Вкл",
    closeS: "Выкл",
    loading: "Загрузка...",
    recordSucc: "Запись сохранена",
    icVe: "Настройка линии запрета электромобиля",
    Perion: "Настройка периметра распознавания пламени",
    ClosePerimeter: "Выключить периметр",
    UDPSet: "Настройки UDP",
    defaultSet: "Восстановить параметры по умолчанию",
    AuxiSet: "Вспомогательное управление",
    PTZSet: "Поворотная камера",
    relayOut: "Включить выход реле",
    turnOut: "Выключить выход реле",
    relayCont: "Управление реле по тревоге",
    RestSystem: "Перезагрузка устройства",
    SubDef: "Восстановить эти параметры? Продолжить?",
    ScreenWidth: "Ширина кадра",
    XAxis: "Ось X",
    ScrHei: "Высота кадра",
    YAxis: "Ось Y",
    Status: "Статус",
    UDPDomain: "Домен UDP",
    UDPIP: "IP UDP",
    UDPPort: "Порт UDP",
    Rotamode: "Режим поворота",
    Focusingmode: "Режим поворота камеры",
    SIPOrig: "Исходный SIP",
    MoveSpeed: "Скорость перемещения, об/мин",
    MoveDist: "Переместить на заданное расстояние",
    RestSucc: "Перезагрузка выполнена",
    RestFail: "Перезагрузка не удалась",
    lnesCtrl: "Объектив",
    lensMode: "Режим поворота объектива",
    lnesRole: "Скорость поворота объектива",
    lnesMove: "Скорость перемещения объектива",
    MovingSteps: "Шаги перемещения камеры",
    RotationalSpeed: "Скорость поворота камеры",
    contiRotate: "По скорости",
    rotateOne: "По шагам",
    manualFocus: "Ручная фокусировка",
    cameraCtrl: "Управление",
    PleaseSelectDevice: "Выберите устройство",
    recoverSuc: "Восстановление выполнено",
    recoverFial: "Восстановление не удалось",
    noPlayStream: "В этом окне нет видео",
    Resetlens: "Сброс объектива",
    speed: "Скорость",
    pointId: "ID точки",
    Monist: "Список мониторинга",
    Monitrol: "Управление мониторингом",

    ctrl: "Управление камерой",
    ctrls: "Управление устройством",
    Blup: "Увеличить",
    minification: "Уменьшить",
    Spln: "Переключить раздельный экран",
    Voiion: "Голосовая связь",
    Coordinate: "Выбор координат",
    tuiresvo: "Не выбрано устройство для голосовой связи",
    ntroah: "Не выбрано устройство для трансляции",
    ationMo: "Режим повторной проверки",
    ImageMo: "Режим распознавания изображения",
    FlameMo: "Режим распознавания пламени",
    MaxThres: "Макс. порог проверки",
    minThres: "Мин. порог проверки",
    Coordinates: "Координаты",
    Selerdinates: "Задать координаты",
    GBSetings: "Параметры GBServer",
    IStings: "Параметры ISP",
    Vidngs: "Настройки видео",
    Audtings: "Настройки аудио",
    eara: "Параметры тревоги по пламени",
    Electmeters: "Параметры тревоги электромобиля",
    Elecgs: "Линия запрета электромобиля",
    Flngs: "Периметр распознавания пламени",
    Alang: "Уведомления по тревоге (http)",
    Warangs: "Настройки WiFi",
    UDPngs: "Настройки UDP",
    roDist: "Расстояние поворота камеры",
    coordinateNo: "Координаты не заданы",
    LensMode: "Режим фокусировки объектива",
    LensSpeed: "Скорость фокусировки объектива",
    LensControl: "Управление объективом",
    refresh: "Обновить видео",
    meterTyp: "Тип параметра",
    perationM: "Режим работы",
    ServerIn: "Информация о сервере",
    RunningMode: "Режим работы",
    alMode: "Обычный режим",
    BWMode: "Чёрно-белый режим",
    MirrorMode: "Зеркальный режим",
    FlipMode: "Режим отражения",
    orFliMo: "Зеркальное отражение",
    WIFIName: "Имя WiFi",
    NotSet: "Не задано",
    restartTips: "Камера будет перезагружена. Продолжить?",
    bcSet: "Основные действия",
    arguInfo: "Параметры",
    leftRo: "Поворот влево",
    rightRo: "Поворот вправо",
    reloadCamera: "Подтвердите перезагрузку камеры",
    eBikeTips: "Настроить линию запрета электромобиля?",
    flameTips: "Настроить периметр распознавания пламени?",
}
